import React from 'react';
import { useHistory } from 'react-router-dom';

import { Formik, Form, FormikValues } from 'formik';
import * as yup from 'yup';

import Field from 'components/FieldWithoutGrid';
import useStoreTranslation from 'hooks/useStoreTranslation';

import {
  Container,
  Header,
  FieldsContainer,
  Input,
  BackButton,
  NextButton,
  ButtonsContainer,
  ButtonLine,
} from '../../styles';

export interface ConfirmEmailValues {
  email: string;
}

interface Props {
  values: ConfirmEmailValues | null;
  onSubmit: (values: ConfirmEmailValues) => void;
}

const ConfirmEmail = ({ values, onSubmit }: Props) => {
  const { t } = useStoreTranslation();
  const history = useHistory();

  const validationSchema = yup.object().shape({
    email: yup.string().email().noPlusSign().required(),
  });

  const initialValues: ConfirmEmailValues = {
    email: values?.email || '',
  };

  const handleBack = () => history.goBack();

  const handleSubmit = async (formValues: ConfirmEmailValues) => onSubmit(formValues);

  return (
    <Formik
      initialStatus={{ rightCheckIfIsValid: true }}
      initialValues={values || initialValues}
      isInitialValid={(formik: FormikValues) => validationSchema.isValidSync(formik.initialValues)}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isValid }: FormikValues) => (
        <Form>
          <Container>
            <Header>{t('login.confirmEmail.title')}</Header>

            <FieldsContainer>
              <Field name="email">
                <Input
                  placeholder={t('login.confirmEmail.placeholder')}
                  autoCapitalize="off"
                  autoCorrect="off"
                  type="email"
                />
              </Field>
            </FieldsContainer>

            <ButtonsContainer>
              <ButtonLine>
                <BackButton type="button" onClick={handleBack}>
                  {t('registrationOnboarding.backButton')}
                </BackButton>
                <NextButton disabled={!isValid}>{t('registrationOnboarding.nextButton')}</NextButton>
              </ButtonLine>
            </ButtonsContainer>
          </Container>
        </Form>
      )}
    </Formik>
  );
};

export default ConfirmEmail;
